import { Location } from "@angular/common";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ROUTING_CONGELAMIENTOS_SALDOS } from "@constants/url.constant";
import { StepStatus } from "@enums/step-status.enum";
import { IStep } from "@interfaces/step.interface";
import { ModalService } from "@services/modal/modal.service";
import { StepsService } from "@services/steps/steps.service";
import { Subscription } from "rxjs";

@Component({
    selector: "app-congelamiento-saldos",
    templateUrl: "./congelamiento-saldos.component.html",
    styleUrls: ["./congelamiento-saldos.component.scss"],
    standalone: false
})
export class CongelamientoSaldosComponent implements OnInit, OnDestroy {
  public STEPS: IStep[] = [
    {
      status: StepStatus.Pending,
      title: "Cuentas y saldos",
      path: ROUTING_CONGELAMIENTOS_SALDOS.CONGELAMIENTO_SALDOS_CUENTAS,
      sessionStorage: "step_1",
    },
    {
      status: StepStatus.Pending,
      title: "Confirmar",
      path: ROUTING_CONGELAMIENTOS_SALDOS.CONGELAMIENTO_SALDOS_CONFIRMAR,
      sessionStorage: "step_2",
    },
  ];
  public currentStep: number = 0;
  showStepper: boolean = true;
  subs = new Subscription();

  constructor(
    private readonly location: Location,
    private readonly stepsService: StepsService,
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
    private readonly modalService: ModalService
  ) {
    stepsService.steps = this.STEPS;
  }
  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  ngOnInit(): void {
    this.subs.add(
      this.stepsService.showStepper.subscribe((value) => {
        this.showStepper = value;
      })
    );
  }

  async goBack() {
    this.stepsService.actualStep === 1
      ? await this.modalService.congelamientoSaldosExitModal()
      : this.location.back();
  }
}
